import 'whatwg-fetch';
import makeAuth0Lock from './auth';

window.addEventListener('load', () => {
  const isLocal = false;

  if (!window.Auth0Lock) {
    return;
  }

  const lock = makeAuth0Lock(isLocal, {
    closable: true,
  });

  lock.on('signup submit', () => {
    analytics.track('Lead');
  });

  function showAuth0Error() {
    const modal = document.querySelectorAll('.modal')[0];
    const modalClosebutton = document.querySelectorAll('.modal-close-button')[0];

    modal.classList.remove('hidden');
    modalClosebutton.addEventListener('click', () => {
      modal.classList.add('hidden');
    });
  }

  const signupButtons = document.querySelectorAll('.signup');
  for (let i = 0; i < signupButtons.length; i += 1) {
    signupButtons[i].addEventListener('click', () => {
      if (window.sessionStorage && window.sessionStorage.mct) {
        window.location.href = '/free-trial/';
      } else if (window.Auth0Lock) {
        lock.show({ allowLogin: false });
        analytics.track('signup click');
      } else {
        showAuth0Error();
      }
    });
  }

  // const contactButtons = document.querySelectorAll('.contact-link');
  // for (let i = 0; i < contactButtons.length; i += 1) {
  //   contactButtons[i].addEventListener('click', () => {
  //     if (window.Intercom && window.Intercom.toString().length > 100) {
  //       // hack to check if Intercom is actually initialized... must be a better way
  //       window.Intercom('show');
  //     } else {
  //       window.location = 'mailto:support@logrocket.com';
  //     }
  //   });
  // }
}, false);
